export default __webpack_public_path__ + "b6ff3b4e72b3a897d674a6e90f8001e2.svg";